export default "__VITE_ASSET__66943ec7__"